// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


const _hostName = window.location.hostname;
let _baseUrl: string = null;
let _baseUrlRpps: string = null;
let _baseUrlCo: string = null;

switch (_hostName) {
    // Teste & Desenvolvimento
  case 'teste.certificated.certificaonline.institutototum.net.br':
    _baseUrl = 'https://teste.api.certificaonline.institutototum.net.br';
    _baseUrlRpps = null;
    _baseUrlCo = null;
    break;

  // Localhost -livereload ionic
  case 'localhost':
    _baseUrl = 'https://api.certificaonline.institutototum.com.br';
    _baseUrlRpps = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlCo = 'https://api.certificaonline.institutototum.com.br';
    _baseUrl = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlRpps = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlCo = 'https://api.rpps.certificaonline.institutototum.com.br';
    break;

    // Producao
  default:
    _baseUrl = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlRpps = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlCo = 'https://api.rpps.certificaonline.institutototum.com.br';
}

export const environment = {
  production: false,
  version: '0.0.01',
  applicationName: 'PROFISSIONAIS CERTIFICADOS PELO INSTITUTO TOTUM',
  baseUrl: _baseUrl,
  baseUrlRpps: _baseUrlRpps,
  baseUrlCo: _baseUrlCo
};
